// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2r6jb","index":"styles_index__y4tdz"};